import { trigger, transition, style, animate } from '@angular/animations';
import { Component, input, signal } from '@angular/core';
import { faCircleInfo, IconDefinition } from '@fortawesome/pro-regular-svg-icons';

@Component({
  selector: 'eiq-custom-tooltip',
  templateUrl: 'custom-tooltip.component.html',
  styleUrls: ['./custom-tooltip.component.scss'],
  animations: [
    trigger('overlayAnimation', [
      transition(':enter', [
        style({
          opacity: 0,
          scale: 0.8
        }),
        animate(
          '250ms cubic-bezier(.17,.67,1,1.04)',
          style({
            opacity: 1,
            scale: 1
          })
        )
      ]),
      transition(':leave', [
        style({
          opacity: 1,
          scale: 1
        }),
        animate(
          '250ms cubic-bezier(.17,.67,1,1.04)',
          style({
            opacity: 0.8,
            scale: 0.8
          })
        )
      ])
    ])
  ]
})
export class CustomTooltipComponent {
  icon$ = input<IconDefinition>(faCircleInfo);

  showToolTip$ = signal<boolean>(false);
}
